import { render, staticRenderFns } from "./ServerForm.vue?vue&type=template&id=7cd056dd&scoped=true"
import script from "./ServerForm.vue?vue&type=script&lang=js"
export * from "./ServerForm.vue?vue&type=script&lang=js"
import style0 from "./ServerForm.vue?vue&type=style&index=0&id=7cd056dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd056dd",
  null
  
)

export default component.exports